import React from 'react';
import Cookie from './Cookie';
import { useSelector } from 'react-redux';
import { DidomiSDK, IDidomiObject } from '@didomi/react';
import { IReduxRootState } from '../app/reduxRootState.interface';

let didomiSdk: IDidomiObject;

const CookieManager = () => {
    const app = useSelector((state: IReduxRootState) => state.app);
    const DIDOMI_API_KEY = app.appConfig.DIDOMI_API_KEY;
    const DIDOMI_ENABLED = app.appConfig.DIDOMI_ENABLED;
    const onReadyDidomi = (didomi: IDidomiObject) => {
        didomiSdk = didomi;
        didomiSdk.preferences.show();
    };

    return (
        <React.Fragment>
            <Cookie />
            {DIDOMI_ENABLED && (
                <DidomiSDK
                    apiKey={DIDOMI_API_KEY}
                    gdprAppliesGlobally={true}
                    onReady={onReadyDidomi}
                />
            )}
        </React.Fragment>
    );
};

export default CookieManager;
